import { getLocalizedMessage, SupportedLanguage } from "@pimo/pimo-l10n";
import { LockDetail } from "@pimo/resource-lock-plugin";

export const getLockedByMessage = (
  subject:
    | "item"
    | "settingsPage"
    | "project"
    | "project-update"
    | "parent-project",
  language: SupportedLanguage,
  lockDetails?: Partial<LockDetail>
) => {
  if (!lockDetails?.isLocked) {
    return undefined;
  }

  let translationKey;
  switch (subject) {
    case "item":
      translationKey = "lockDetail.lockedItem";

      break;
    case "settingsPage":
      translationKey = "lockDetail.lockedSettings";

      break;
    case "project":
      translationKey = "lockDetail.lockedProject";

      break;
    case "parent-project":
      translationKey = "lockDetail.lockedProjectParent";

      break;
    case "project-update":
      translationKey = "lockDetail.lockedProjectUpdate";

      break;
  }

  if (!translationKey) {
    return;
  }

  return lockDetails.lockedBy
    ? getLocalizedMessage(language, translationKey, {
        lockedBy: lockDetails.lockedBy,
      })
    : getLocalizedMessage(language, translationKey + "Unknown");
};
